// docs/78 BW5, docs/83 PO10 — what a ping is, on the World chart and the encounter board alike.
import { deviceNow } from './time';

/** How long a ping stays up (ms), and the gap between my own pings. */
export const PING_MS = 4000;
export const PING_GAP_MS = 1000;
/** The kinds (11 §10.2): look, go, danger, hold, help. */
export const PING_DANGER = 2;
export const PING_SOUND = ['ping.look', 'ping.go', 'ping.danger', 'ping.hold', 'ping.help'] as const;

/** One gate for all my pings: true (and the clock starts again) when the last is old enough. */
let sentAt = 0;
export function mayPing(): boolean {
  const now = deviceNow();
  if (now - sentAt < PING_GAP_MS) return false;
  sentAt = now;
  return true;
}
